<!-- ComponentIndexHealth -->

<template>
  <div
    style="
      display: flex;
      flex-direction: row;
      overflow-x: scroll;
      background-color: #ffffff;
      padding: 4px 0;
    "
  >
    <div
      v-for="(item, index) of healthData.records"
      :key="index"
      style="
        display: block;
        margin: 0 4px;
        background-color: #ffffff;
        text-align: center;
      "
      @click="
        $router.push({ path: 'health-detail', query: { id: item.brandShopId } })
      "
    >
      <van-image
        :src="item.headImage"
        fit="contain"
        height="120"
        lazy-load
        width="120"
      />
      <div
        class="van-ellipsis"
        style="width: 120px; font-size: 16px; margin-top: 8px"
      >
        {{ item.name }}
      </div>

      <div
        style="
          display: flex;
          margin-top: 8px;
          justify-content: center;
          font-size: 12px;
        "
      >
        <van-tag style="font-size: 9px" type="warning">{{
          item.level
        }}</van-tag>
        <van-tag style="margin-left: 1px; font-size: 9px" text-color="#fff"
          >{{ item.distance }}km</van-tag
        >
      </div>

      <div style="margin: 8px 0">
        <img
          src="https://goods-images-1259573531.cos.ap-chengdu.myqcloud.com/goods-images-1259573531/20241230/t81502o1cbv1u2pptwopkson.png"
          style="
            width: 18px;
            height: 18px;
            display: block;
            margin-top: 4px;
            float: left;
          "
        />
        <span
          style="
            color: #f84f43;
            font-size: 18px;
            line-height: 24px;
            display: block;
            margin-top: 4px;
            float: left;
          "
        >
          {{ (item.minPrice / 100).toFixed(2) }}
          <span style="font-size: 12px">起</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { api_get_hospital_list } from "@/api/goods-api";

export default {
  data() {
    return {
      healthData: {},
    };
  },

  mounted() {
    this.getHealthData_flag();
  },

  methods: {
    getHealthData_flag() {
      api_get_hospital_list(0, 10, "", "", "").then((res) => {
        if (res.code === 0) {
          this.healthData = {
            records: [].concat(
              res.data.records.map((r) => {
                r.goodsList.sort((a, b) => a.price - b.price);
                if (r && r.goodsList && r.goodsList.length > 0) {
                  r.minPrice = r.goodsList[0].price;
                }
                return r;
              })
            ),
            id: 8,
          };
        } else {
          budo_log.info("#350 获取体验医院数据失败");
        }
      });
    },
  },
};
</script>
